import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionCTPage = ({ path }) => (
  <>
    <Meta
      title="Cloud Transformation Solution Provider | ATC Digital Business Solutions"
      description="Accelerate your cloud transformation journey with expertise in managed services, security, consulting, assessment, operations, and Kubernetes."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/cloud-transformation-banner.jpg"
          title="Cloud Transformation - Built for scaling business."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Accelerate your cloud journey with expertise in managed services,
            security, consulting, assessment, operations and kubernetes.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Cloud Adoption for Performance
                </h2>
                <p className="white-txt">
                  As organizations position themselves to outperform competitors
                  and scale their businesses to new heights, resources and
                  infrastructure are the main constraints that they need to
                  manage effectively. Cloud computing provides your organization
                  the flexibility it needs to meet infrastructure requirements
                  on demand. Cloud migration saves cost and prepares you better
                  for on-demand scaling. IT Agility, DevOps, Mobility, AI and
                  Machine Learning are the top factors driving cloud adoption as
                  per a LogicMonitor Survey - Cloud Vision 2020.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="cloudTransformation"
          flyText="Cloud Transformation"
          flyBoxImage="solutions/cloud-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Phased Approach to Migration - AWS and Google Cloud Platforms
                </h2>
                <p>
                  The phases of cloud migration: Segregate workloads based on
                  business requirements and security to determine suitability
                  for cloud migration. Amazon Web Services (AWS) provides
                  multiple methods to migrate workloads. With Windows
                  Applications or SAP, seamlessly move your workloads to AWS to
                  scale faster while saving cost. To ensure the success of your
                  cloud migration, it is critical to have 24x7 support to keep
                  track of your system maintenance and upgrades.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Cloud Solutions
                    <br />
                    for Growth
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Consulting</h3>
                        <p>Advisory and Assessment.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Operations</h3>
                        <p>Migration, Optimization and Analytics.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Managed Services</h3>
                        <p>Remote Cloud and Infrastructure management.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Security</h3>
                        <p>Threat detection and rapid response.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionCTPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionCTPage;
